module.exports = __webpack_public_path__ + "static/media/spring-che-small@2x.5d34e0f5.png";